import axios from "axios";
import { useEffect, useState } from "react";
import UserCard from "./UserCard";
import RecentVentaComprobantes from "./RecentVentaComprobantes";
import TopPremiosTeaser from "./TopPremiosTeaser";
import {
  PlusCircle,
  Gift,
  Package,
  LayoutGrid,
} from "lucide-react";


interface User {
  usuario_id: number;
  premios_recibidos: number;
  retos_completado: number;
  puntos: number;
  name: string;
}

interface HomeProps {
  setView: (view: string) => void;
  setVentaModalOpen: (open: boolean) => void;
}

function formatPuntos2(n: number) {
  const v = Math.round((Number(n) || 0) * 100) / 100;
  return v.toLocaleString("es-CR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const Home = ({ setView, setVentaModalOpen }: HomeProps) => {
  const [foto, setFoto] = useState("");
  const [usuario, setUsuario] = useState<User>();
  const [pedidosCount, setPedidosCount] = useState<number | null>(null);

  const getUser = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/usuarios/home/${sessionStorage.getItem("email")}`,
        {
          headers: { "auth-token": `${sessionStorage.getItem("token")}` },
          params: { email: sessionStorage.getItem("email") },
        }
      );
      setUsuario(response.data);
      setFoto(response.data.foto);
    } catch (error) {
      console.log(error);
    }
  };

  const getPedidosCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pedidos/usuario/${sessionStorage.getItem("user_id")}`,
        { headers: { "auth-token": `${sessionStorage.getItem("token")}` } }
      );
      setPedidosCount(Array.isArray(response.data) ? response.data.length : 0);
    } catch {
      setPedidosCount(null);
    }
  };

  useEffect(() => {
    getUser();
    getPedidosCount();
  }, []);


  return (
    <div className="w-full max-w-3xl space-y-5 px-4 pb-2 md:max-w-none">
      <UserCard
        foto={foto}
        puntos={usuario?.puntos || 0}
        retos={usuario?.retos_completado || 0}
        name={usuario?.name || ""}
      />

      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        <div className="rounded-2xl border border-gray-200 bg-white p-3 text-center shadow-sm sm:p-4">
          <p className="text-xs text-gray-500 sm:text-sm">Puntos</p>
          <p className="text-lg font-bold text-[#205f43] sm:text-xl">
            {formatPuntos2(usuario?.puntos ?? 0)}
          </p>
        </div>
        <div className="rounded-2xl border border-gray-200 bg-white p-3 text-center shadow-sm sm:p-4">
          <p className="text-xs text-gray-500 sm:text-sm">Pedidos</p>
          <p className="text-lg font-bold text-gray-900 sm:text-xl">
            {pedidosCount ?? "—"}
          </p>
        </div>
        <button
          type="button"
          onClick={() => setView("Premios")}
          className="rounded-2xl border border-gray-200 bg-white p-3 text-center shadow-sm transition hover:border-[#205f43]/50 hover:shadow md:p-4"
          title="Ver catálogo y canjear premios"
        >
          <p className="text-xs text-gray-500 sm:text-sm">Premios</p>
          <p className="text-lg font-bold text-gray-900 sm:text-xl">
            {usuario?.premios_recibidos ?? 0}
          </p>
        </button>
      </div>

      <div>
        <h2 className="mb-2 text-sm font-semibold text-gray-800">
          Accesos rápidos
        </h2>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          <button
            type="button"
            onClick={() => setVentaModalOpen(true)}
            className="flex flex-col items-center gap-2 rounded-2xl border border-gray-200 bg-white p-3 text-sm font-medium text-gray-800 shadow-sm transition hover:border-[#205f43]/40"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#205f43]/10 text-[#205f43]">
              <PlusCircle className="h-5 w-5" />
            </span>
            Agregar venta
          </button>
          <button
            type="button"
            onClick={() => setView("Premios")}
            className="flex flex-col items-center gap-2 rounded-2xl border border-gray-200 bg-white p-3 text-sm font-medium text-gray-800 shadow-sm transition hover:border-[#205f43]/40"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-pink-50 text-pink-600">
              <Gift className="h-5 w-5" />
            </span>
            Premios
          </button>
          <button
            type="button"
            onClick={() => setView("Productos")}
            className="flex flex-col items-center gap-2 rounded-2xl border border-gray-200 bg-white p-3 text-sm font-medium text-gray-800 shadow-sm transition hover:border-[#205f43]/40"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cyan-50 text-cyan-700">
              <Package className="h-5 w-5" />
            </span>
            Productos
          </button>
          <button
            type="button"
            onClick={() => setView("Pedidos")}
            className="flex flex-col items-center gap-2 rounded-2xl border border-gray-200 bg-white p-3 text-sm font-medium text-gray-800 shadow-sm transition hover:border-[#205f43]/40"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-violet-50 text-violet-700">
              <LayoutGrid className="h-5 w-5" />
            </span>
            Pedidos
          </button>
        </div>
      </div>

      <TopPremiosTeaser onVerMas={() => setView("Premios")} />

      <RecentVentaComprobantes />
    </div>
  );
};

export default Home;
